import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-marker-icon-park",
  "use": "spr-marker-icon-park-usage",
  "viewBox": "0 0 16 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 30\" id=\"spr-marker-icon-park\"><defs><path id=\"spr-marker-icon-park_a\" d=\"M576 222.52c0-6.35 3.8-12.06 7.17-17.1a1 1 0 0 1 1.66 0c3.36 5.04 7.17 10.76 7.17 17.1 0 5.2-2.41 8.1-7 8.46V234a1 1 0 0 1-1 1 1 1 0 0 1-1-1v-3.02c-4.59-.36-7-3.27-7-8.46zm8-14.74c-3.08 4.65-6 9.47-6 14.74 0 4.06 1.6 6.14 5 6.46v-2.4l-2.55-1.7a1 1 0 0 1-.28-1.37 1 1 0 0 1 1.38-.28l1.45.96v-4.11a1 1 0 0 1 1-1 1 1 0 0 1 1 1v1.13l1.45-.96a1 1 0 0 1 1.38.27 1 1 0 0 1-.28 1.38l-2.55 1.7v5.38c3.4-.32 5-2.4 5-6.46 0-5.27-2.92-10.1-6-14.74z\" /></defs><use fill=\"#fff\" xlink:href=\"#spr-marker-icon-park_a\" transform=\"translate(-576 -205)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/marker-icon-park.svg
// module id = 266
// module chunks = 0